import { render, staticRenderFns } from "./CcLevelChip.vue?vue&type=template&id=06a31c32&scoped=true"
import script from "./CcLevelChip.vue?vue&type=script&setup=true&lang=js"
export * from "./CcLevelChip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CcLevelChip.vue?vue&type=style&index=0&id=06a31c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a31c32",
  null
  
)

export default component.exports